import React from "react";
import styled from "@emotion/styled";
import { getSrcImage } from "@utils";

const DisplayGrid = styled.div`
  display: grid;
  grid-template-columns: 36px 1fr;
  grid-gap: 12px;
  font-size: ${props => props.fontSize};
  color: ${props => props.color};
`;

const CardImage = styled.img`
  width: 100%;
  height: 26px;
`;

const CreditCardDisplay = ({
  firstName,
  lastName,
  accountType,
  accountNumber,
  expirationDate,
  fontSize,
  color,
  setClassName = ""
}) => (
  <DisplayGrid
    className={setClassName}
    fontSize={fontSize ? fontSize : "inherit"}
    color={color ? color : "inherit"}
  >
    <CardImage src={getSrcImage(accountType)} alt="card" />
    <div className="cc-display-card-container">
      {firstName && lastName && (
        <div>
          {firstName} {lastName}
        </div>
      )}

      <div>{accountNumber}</div>
      <div className="cc-display-expiration">{expirationDate}</div>
    </div>
  </DisplayGrid>
);

export default CreditCardDisplay;
